<template>
  <div class="hidden md:block h-full min-h-36 bg-white pb-16">
    <h1 class="text-center pt-10 pb-16 text-gray-800 text-4xl font-extrabold">
      Our Partner Physicians
    </h1>
    <div class="flex justify-center items-center">
      <ul class="grid grid-cols-1 gap-6 mx-36">
        <li
          class="flex p-6 items-center justify-center flex-col gap-2 text-center border border-gray-200 rounded-xl hover:bg-orange-50"
          v-for="(item, index) in itemHowItsWork"
          :key="index"
        >
          <span>
            <img
              class="w-28 h-28 object-cover rounded-full shadow"
              :src="require(`@/assets/images/${item.profile}`)"
              alt=""
            />
          </span>
          <div>
            <h2 class="text-orange-600 font-semibold text-lg">
              {{ item.name }}
            </h2>
            <p class="text-base text-black/80 font-medium">
              {{ item.specialization }}
            </p>
          </div>
          <div class="grid grid-cols-2 gap-3 mt-3">
            <div>
              <p class="text-xs text-gray-600">Today Schedule</p>
              <p class="text-sm">{{ item.schedule }}</p>
            </div>
            <div
              class="text-sm flex items-center justify-center bg-primary border border-orange-400 text-white px-16 min-h-12 rounded-md hover:bg-orange-50 hover:text-orange-600 transition"
            >
              Profile
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import IllustratorCalendar from "@/components/svgs/illustratorCalendar.vue";
import IllustratorVideoCall from "@/components/svgs/illustratorVideoCall.vue";
import IllustratorDocument from "@/components/svgs/illustratorDocument.vue";
export default {
  components: {
    IllustratorCalendar,
    IllustratorVideoCall,
    IllustratorDocument,
  },
  setup() {
    const itemHowItsWork = ref([
      {
        id: 2,
        profile: "doc-lee.jpeg",
        name: "Dr. Leandro Lee Uyguanco",
        specialization: "General Medicine / Ophthalmology",
        consultationDate: "June 18, 2025",
        schedule: "9:00AM - 5:00PM",
        description:
          "Join a secure video consultation with one of our licensed doctors. Discuss your symptoms and medical concerns from the comfort of your home",
      },
    ]);
    return {
      itemHowItsWork,
    };
  },
};
</script>
